module.exports = __webpack_public_path__ + "img/v10.f5631862.png";